import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/globals.css';
import { AuthProvider } from '@/modules/auth/AuthProvider';
import { initA11yPrefs } from '@/stores/a11yStore';
import App from './App';

initA11yPrefs();

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found.');

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
